import React from 'react'

function index() {
  return (
    <div>
      <h1>Hi I am statictics compoennt</h1>
    </div>
  )
}

export default index
